import {AddLocationAlt, EmojiTransportation} from "@mui/icons-material";
import {Stack, Tab, Tabs} from "@mui/material";
import React, {useEffect, useState} from "react";
import {useAuthState} from "react-firebase-hooks/auth";
import {useList} from "react-firebase-hooks/database";
import type {BasePlaces, PlannedPlaces} from "../../firebase/index.js";
import {auth, createItinerariesHookQuery, ItineraryModel, PlaceModel, TripModel} from "../../firebase/index.js";
import {useInMemoryTrip} from "../../redux/InMemoryTripReducer.js";
import {APXHideOnScrollFab} from "../../reusables/APXHideOnScrollFab.jsx";
import APXWebAppBackButton from "../../reusables/APXWebAppBackButton.jsx";
import {webappPaths} from "../../reusables/js/AppRoutes.js";
import {red_900, transport} from "../../reusables/js/APXTheme.js";
import AddNewPlaceBSL from "./AddNewPlaceBSL.jsx";
import AddNewTransportBSL from "./AddNewTransportBSL.jsx";
import ItineraryPlanned from "./ItineraryPlanned.jsx";
import ItinerarySummary from "./ItinerarySummary.jsx";
import ItineraryUnassigned from "./ItineraryUnassigned.jsx";


export default function ItineraryMainFragment() {
	  const [tabIndex, setTabIndex] = useState(0);
	  const duP: BasePlaces = {};
	  const dpP: PlannedPlaces = {};
	  const [unassignedPlaces, setUnassignedPlaces] = useState(duP);
	  const [plannedPlaces, setPlannedPlaces] = useState(dpP);
	  
	  const inMemoryTrip: TripModel = useInMemoryTrip();
	  
	  const [user] = useAuthState(auth);
	  const uid = /*TRUTHY->*/ !!user && user?.uid;
	  
	  const [snapshots, loading, error] = useList(createItinerariesHookQuery(uid, inMemoryTrip.itineraryKey));
	  
	  useEffect(() => {
			 if (/*TRUTHY->*/ !!snapshots && /*NOT->*/ !loading) {
					snapshots.map((snapshot) => {
						  const itinerary: ItineraryModel = ItineraryModel.fromObject(snapshot.val());
						  const uP: BasePlaces = duP;
						  if (/*TRUTHY->*/ !!itinerary.unassignedPlaces) {
								 Object.entries(itinerary.unassignedPlaces).forEach(([key, value]) => {
										uP[key] = PlaceModel.fromObject(value);
								 });
						  }
						  const pP: PlannedPlaces = dpP;
						  if (/*TRUTHY->*/ !!inMemoryTrip.tripDates) {
								 Object.entries(inMemoryTrip.tripDates).forEach(([key, value]) => {
										pP[key] = {};
								 });
						  }
						  if (/*TRUTHY->*/ !!itinerary.plannedPlaces) {
								 Object.entries(itinerary.plannedPlaces).forEach(([key, value]) => {
										const bP: BasePlaces = value;
										if (/*TRUTHY->*/!!bP) {
											  Object.entries(bP).forEach(([key, value]) => {
													 bP[key] = PlaceModel.fromObject(value);
											  });
										}
										pP[key] = bP;
								 });
						  }
						  setUnassignedPlaces(uP);
						  setPlannedPlaces(pP);
					});
			 }
	  }, [snapshots]);
	  
	  const [openNewTransportBSL, setOpenNewTransportBSL] = useState(false);
	  const [openNewPlaceBSL, setOpenNewPlaceBSL] = useState(false);
	  
	  return (
				 <>
						<APXWebAppBackButton webAppRoutePath={webappPaths.root}/>
						<Stack direction="row" spacing={2} justifyContent="center" alignItems="center">
							  <Tabs value={tabIndex} onChange={(event, newValue) => setTabIndex(newValue)} centered>
									 <Tab label={"Unassigned"}/>
									 <Tab label={"Planned"}/>
									 <Tab label={"Summary"}/>
							  </Tabs>
						</Stack>
						<Stack mt={2}>
							  {tabIndex === 0 && <ItineraryUnassigned basePlaces={unassignedPlaces}/>}
							  {tabIndex === 1 && <ItineraryPlanned plannedPlaces={plannedPlaces}/>}
							  {tabIndex === 2 && <ItinerarySummary plannedPlaces={plannedPlaces}/>}
						</Stack>
						
						<APXHideOnScrollFab icon={<EmojiTransportation/>} backgroundColour={transport} colour={"white"}
												  sx={{position: "fixed", bottom: 80, right: 16, visibility: inMemoryTrip.isCompleted ? "hidden" : "visible"}}
												  onClick={() => setOpenNewTransportBSL(true)}/>
						
						<APXHideOnScrollFab icon={<AddLocationAlt/>} backgroundColour={red_900} colour={"white"}
												  sx={{position: "fixed", bottom: 16, right: 16, visibility: inMemoryTrip.isCompleted ? "hidden" : "visible"}}
												  onClick={() => setOpenNewPlaceBSL(true)}/>
						
						{openNewTransportBSL && <AddNewTransportBSL onClose={() => setOpenNewTransportBSL(false)} uid={uid} place={null}/>}
						{openNewPlaceBSL && <AddNewPlaceBSL onClose={() => setOpenNewPlaceBSL(false)} uid={uid} place={null}/>}
				 </>
	  );
}